<template>
  <div>
    <div class="d-flex align-items-center mb-2" v-for="(item, index) in emails" :key="index">
      <b-form-input
        v-model="emails[index]"
        placeholder="Enter the email.."
        class="mb-2"
        type="email"
        required
      ></b-form-input>
      <div
        v-if="index !== 0"
        @click="handleDeleteEmail(index)"
        class="material-icons icon-delete ml-2 pointer"
      >
        clear
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <b-button
        v-if="emails.length < minEmails"
        variant="primary"
        class="w-50 mx-auto mb-3"
        @click="addInputEmail"
        >+ Additional Emails</b-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      emails: [''],
      minEmails: 3,
    };
  },
  methods: {
    addInputEmail() {
      this.emails.push('');
    },
    handleDeleteEmail(id) {
      this.emails = this.emails.filter((email, index) => index !== id);
    },
  },
  watch: {
    emails(value) {
      this.$emit('update:emailsToReport', value);
    },
  },
};
</script>
